module.exports = __webpack_public_path__ + "static/img/2.5b78dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/2.png
// module id = 2TdG
// module chunks = 96